import React from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import conf from "../../../config.js";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export default class JadwalPerGuru extends React.Component {
    constructor(props) {
        super(props);
        const now = new Date();
        const month = now.getMonth() + 1;
        const year = now.getFullYear();
        const defaultTA = month >= 7 ? `${year} / ${year + 1}` : `${year - 1} / ${year}`;
        const defaultSem = month >= 7 ? "1" : "2";

        this.state = {
            institusi_id: "",
            tahun_ajaran: defaultTA,
            semester: defaultSem,
            kurikulum: "merdeka",
            loading: true,
            jadwal: [],
            waktu_list: [],
            waktu_per_tingkat: {},
            guru_list: [],
            selected_guru: "",
            versi_list: [],
            selected_versi: "",
        };
    }

    componentDidMount() { this.getSession(); }

    getSession() {
        const tokenApi = "Bearer " + localStorage.getItem("token");
        axios.post(`${conf.uri_backend}api/v1/auth/sso/user`, { token: localStorage.getItem("token") }, { headers: { Authorization: tokenApi } })
            .then((res) => {
                const npsn = res.data.access_to;
                axios.get(`${conf.uri_backend}api/v1/select-institusi/${npsn}`, { headers: { Authorization: tokenApi } })
                    .then((instRes) => {
                        this.setState({ institusi_id: instRes.data.id }, () => {
                            this.loadVersi();
                            this.loadJadwal();
                            this.loadWaktu();
                        });
                    })
                    .catch(() => {
                        this.setState({ institusi_id: npsn }, () => {
                            this.loadVersi();
                            this.loadJadwal();
                            this.loadWaktu();
                        });
                    });
            });
    }

    getApiHeaders() { return { headers: { Authorization: "Bearer " + localStorage.getItem("token") } }; }
    getBaseParams() { return `institusi=${this.state.institusi_id}&tahun_ajaran=${this.state.tahun_ajaran}&semester=${this.state.semester}&kurikulum=${this.state.kurikulum}`; }

    getTahunAjaranOptions() {
        const now = new Date();
        const year = now.getFullYear();
        const options = [];
        for (let y = year + 1; y >= year - 3; y--) {
            options.push(`${y} / ${y + 1}`);
        }
        return options;
    }

    onFilterChange(partial) {
        this.setState({ ...partial, selected_guru: "", selected_versi: "", jadwal: [], guru_list: [], versi_list: [], waktu_list: [], loading: true }, () => {
            this.loadVersi();
            this.loadJadwal();
            this.loadWaktu();
        });
    }

    loadVersi() {
        axios.get(`${conf.uri_backend}api/v1/jadwal-v2/versi?${this.getBaseParams()}`, this.getApiHeaders())
            .then((res) => { if (res.data.status) this.setState({ versi_list: res.data.data }); });
    }

    loadWaktu() {
        axios.get(`${conf.uri_backend}api/v1/jadwal-v2/waktu?${this.getBaseParams()}`, this.getApiHeaders())
            .then((res) => {
                if (res.data.status) {
                    const allData = res.data.data || [];
                    const perTingkat = {};
                    allData.forEach(w => {
                        const t = w.tingkat || '_shared';
                        if (!perTingkat[t]) perTingkat[t] = [];
                        perTingkat[t].push(w);
                    });
                    Object.keys(perTingkat).forEach(t => {
                        const seen = {};
                        perTingkat[t] = perTingkat[t].filter(w => {
                            const key = `${w.hari}_${w.jam_ke || ''}_${w.waktu_mulai || ''}_${w.tipe || ''}_${w.urutan || ''}`;
                            if (seen[key]) return false;
                            seen[key] = true;
                            return true;
                        });
                    });
                    const seen = {};
                    const flatData = allData.filter(w => {
                        const key = `${w.hari}_${w.jam_ke || ''}_${w.waktu_mulai || ''}_${w.tipe || ''}_${w.urutan || ''}`;
                        if (seen[key]) return false;
                        seen[key] = true;
                        return true;
                    });
                    this.setState({ waktu_list: flatData, waktu_per_tingkat: perTingkat });
                }
            })
            .catch(() => { });
    }

    getWaktuByHari(tingkat) {
        const { waktu_list, waktu_per_tingkat } = this.state;
        let sourceList = waktu_list;
        if (tingkat && waktu_per_tingkat) {
            if (waktu_per_tingkat[tingkat]) {
                sourceList = waktu_per_tingkat[tingkat];
            } else if (waktu_per_tingkat['_shared']) {
                sourceList = waktu_per_tingkat['_shared'];
            }
        }
        const waktuByHari = {};
        sourceList.forEach((w) => {
            const h = Number(w.hari);
            if (!waktuByHari[h]) waktuByHari[h] = [];
            waktuByHari[h].push(w);
        });
        Object.keys(waktuByHari).forEach(h => {
            waktuByHari[h].sort((a, b) => {
                if (a.urutan !== undefined && b.urutan !== undefined) return a.urutan - b.urutan;
                return (Number(a.jam_ke) || 0) - (Number(b.jam_ke) || 0);
            });
        });
        return waktuByHari;
    }

    /**
     * For guru views: find the tingkat with the most waktu slots.
     */
    getBestTingkatForGuru(guruNama) {
        const { jadwal, waktu_per_tingkat } = this.state;
        if (!waktu_per_tingkat) return null;
        const guruJadwal = jadwal.filter(j => j.guru_nama === guruNama);
        const tingkatSet = new Set();
        guruJadwal.forEach(j => {
            if (j.kelas) tingkatSet.add(String(j.kelas));
        });
        let best = null;
        let maxSlots = 0;
        for (const t of tingkatSet) {
            const slots = (waktu_per_tingkat[t] || []).length;
            if (slots > maxSlots) {
                maxSlots = slots;
                best = t;
            }
        }
        return best;
    }

    loadJadwal() {
        const versiParam = this.state.selected_versi ? `&versi_id=${this.state.selected_versi}` : "";
        const guruParam = this.state.selected_guru ? `&guru_nama=${encodeURIComponent(this.state.selected_guru)}` : "";
        axios.get(`${conf.uri_backend}api/v1/jadwal-v2/jadwal/guru?${this.getBaseParams()}${versiParam}${guruParam}`, this.getApiHeaders())
            .then((res) => {
                if (res.data.status) {
                    this.setState({ jadwal: res.data.data, guru_list: res.data.guru_list || [], loading: false });
                } else {
                    this.setState({ jadwal: [], loading: false });
                }
            }).catch(() => this.setState({ loading: false }));
    }

    renderHariLabel(h) {
        return { 1: "Senin", 2: "Selasa", 3: "Rabu", 4: "Kamis", 5: "Jumat", 6: "Sabtu", 7: "Minggu" }[h] || h;
    }

    exportPdf() {
        const el = document.getElementById("jadwal-print-area");
        if (!el) return;
        const { selected_guru, tahun_ajaran, semester } = this.state;

        html2canvas(el, { scale: 2, useCORS: true, backgroundColor: "#ffffff" }).then((canvas) => {
            const imgData = canvas.toDataURL("image/png");
            const imgWidth = canvas.width;
            const imgHeight = canvas.height;
            const orientation = imgWidth > imgHeight ? "l" : "p";
            const pdf = new jsPDF(orientation, "mm", "a4");
            const pdfWidth = pdf.internal.pageSize.getWidth() - 20;
            const pdfHeight = (imgHeight * pdfWidth) / imgWidth;

            pdf.setFontSize(14);
            pdf.setFont(undefined, "bold");
            pdf.text(`Jadwal Mengajar \u2014 ${selected_guru}`, 10, 12);
            pdf.setFontSize(9);
            pdf.setFont(undefined, "normal");
            pdf.text(`Tahun Ajaran: ${tahun_ajaran} | Semester: ${semester}`, 10, 18);

            pdf.addImage(imgData, "PNG", 10, 24, pdfWidth, pdfHeight);
            pdf.save(`Jadwal_Guru_${selected_guru}_${tahun_ajaran.replace(/ /g, "")}_Sem${semester}.pdf`);
        });
    }

    exportExcel() {
        const { jadwal, waktu_list, selected_guru, tahun_ajaran, semester } = this.state;
        if (!jadwal.length) return;

        const hariSet = new Set();
        jadwal.forEach((j) => hariSet.add(j.hari));
        const hariList = Array.from(hariSet).sort();
        const hariLabels = hariList.map((h) => this.renderHariLabel(h));


        const jadwalMatrix = {};
        jadwal.forEach((j) => {
            if (!jadwalMatrix[j.hari]) jadwalMatrix[j.hari] = {};
            if (!jadwalMatrix[j.hari][j.jam_ke]) jadwalMatrix[j.hari][j.jam_ke] = [];
            jadwalMatrix[j.hari][j.jam_ke].push(j);
        });

        const bestTingkatExport = this.getBestTingkatForGuru(selected_guru);
        const waktuByHari = this.getWaktuByHari(bestTingkatExport);
        let templateHari = null; let maxE = 0;
        Object.keys(waktuByHari).forEach(h => { if (waktuByHari[h].length > maxE) { maxE = waktuByHari[h].length; templateHari = h; } });
        const templateSlots = templateHari ? waktuByHari[templateHari] : [];

        const rows = [];
        rows.push([`Jadwal Mengajar \u2014 ${selected_guru}`]);
        rows.push([`Tahun Ajaran: ${tahun_ajaran} | Semester: ${semester}`]);
        rows.push([]);

        const header = ["Jam", "Waktu", ...hariLabels];
        rows.push(header);

        if (templateSlots.length > 0) {
            templateSlots.forEach((slot) => {
                const tipe = slot.tipe || (slot.is_istirahat ? "istirahat" : "pelajaran");
                const isBreak = tipe === "istirahat" || tipe === "upacara" || tipe === "kegiatan";
                const waktu = slot.waktu_mulai && slot.waktu_selesai
                    ? `${slot.waktu_mulai.slice(0, 5)} - ${slot.waktu_selesai.slice(0, 5)}` : "";

                if (isBreak) {
                    const label = slot.keterangan || tipe.charAt(0).toUpperCase() + tipe.slice(1);
                    rows.push(["", waktu, ...hariLabels.map(() => label)]);
                } else {
                    const jamKe = slot.jam_ke;
                    const row = [jamKe, waktu];
                    hariList.forEach((hari) => {
                        const cells = (jadwalMatrix[hari] && jadwalMatrix[hari][jamKe]) || [];
                        if (cells.length > 0) {
                            row.push(cells.map(c => `${c.mapel_nama} (${c.rombel_nama})`).join(", "));
                        } else {
                            row.push("");
                        }
                    });
                    rows.push(row);
                }
            });
        } else {
            let maxJam = 0;
            jadwal.forEach((j) => { if (j.jam_ke > maxJam) maxJam = j.jam_ke; });
            for (let jam = 1; jam <= maxJam; jam++) {
                const row = [jam, ""];
                hariList.forEach((hari) => {
                    const cells = (jadwalMatrix[hari] && jadwalMatrix[hari][jam]) || [];
                    if (cells.length > 0) {
                        row.push(cells.map(c => `${c.mapel_nama} (${c.rombel_nama})`).join(", "));
                    } else {
                        row.push("");
                    }
                });
                rows.push(row);
            }
        }

        const ws = XLSX.utils.aoa_to_sheet(rows);
        ws["!cols"] = [
            { wch: 5 },
            { wch: 14 },
            ...hariLabels.map(() => ({ wch: 40 }))
        ];
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, selected_guru.slice(0, 31));
        const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        saveAs(new Blob([wbout], { type: "application/octet-stream" }), `Jadwal_Guru_${selected_guru}_${tahun_ajaran.replace(/ /g, "")}_Sem${semester}.xlsx`);
    }

    renderMatrix() {
        const { jadwal } = this.state;
        if (!jadwal.length) return <div className="pc-empty-state"><i className="bx bx-calendar-x"></i><p>Tidak ada data jadwal</p></div>;

        const jadwalMatrix = {};
        jadwal.forEach((j) => {
            if (!jadwalMatrix[j.hari]) jadwalMatrix[j.hari] = {};
            if (!jadwalMatrix[j.hari][j.jam_ke]) jadwalMatrix[j.hari][j.jam_ke] = [];
            jadwalMatrix[j.hari][j.jam_ke].push(j);
        });

        const bestTingkat = this.getBestTingkatForGuru(this.state.selected_guru);
        const waktuByHari = this.getWaktuByHari(bestTingkat);
        const hariSet = new Set();
        jadwal.forEach((j) => hariSet.add(Number(j.hari)));
        Object.keys(waktuByHari).forEach(h => hariSet.add(Number(h)));
        const hariList = Array.from(hariSet).sort((a, b) => a - b);
        const maxEntries = Math.max(...hariList.map(h => (waktuByHari[h] || []).length), 0);

        if (maxEntries === 0) {
            let maxJam = 0;
            jadwal.forEach((j) => { if (j.jam_ke > maxJam) maxJam = j.jam_ke; });
            return this.renderSimpleMatrix(jadwalMatrix, hariList, maxJam);
        }

        return (
            <div className="pc-table-container" style={{ overflowX: 'auto' }}>
                <table className="pc-schedule-table pc-schedule-premium">
                    <thead>
                        <tr>
                            <th className="pc-th-jam" style={{ minWidth: 40 }}>#</th>
                            {hariList.map((h) => (
                                <th key={h} className="pc-th-hari">{this.renderHariLabel(h)}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {Array.from({ length: maxEntries }, (_, rowIdx) => (
                            <tr key={rowIdx}>
                                <td className="pc-jam-cell" style={{ textAlign: 'center', color: '#94a3b8', fontSize: 11 }}>{rowIdx + 1}</td>
                                {hariList.map((hari) => {
                                    const entry = (waktuByHari[hari] || [])[rowIdx];
                                    if (!entry) return <td key={hari} className="pc-schedule-cell pc-cell-noSlot"></td>;
                                    const tipe = entry.tipe || (entry.is_istirahat ? 'istirahat' : 'pelajaran');
                                    const isBreak = tipe === 'istirahat' || tipe === 'upacara' || tipe === 'kegiatan';
                                    const fmtTime = (t) => t ? t.substring(0, 5) : '';
                                    const waktuLabel = `${fmtTime(entry.waktu_mulai)} - ${fmtTime(entry.waktu_selesai)}`;

                                    if (isBreak) {
                                        return (
                                            <td key={hari} className="pc-schedule-cell pc-cell-break-inline">
                                                <div className="pc-cell-break-tag">
                                                    <i className={`bx ${tipe === 'istirahat' ? 'bx-coffee' : tipe === 'upacara' ? 'bx-flag' : 'bx-star'}`}></i>
                                                    {entry.keterangan || tipe}
                                                    <span style={{ fontSize: 10, opacity: 0.7, display: 'block' }}>{waktuLabel}</span>
                                                </div>
                                            </td>
                                        );
                                    }
                                    const jamKe = Number(entry.jam_ke);
                                    const cells = (jadwalMatrix[hari] && jadwalMatrix[hari][jamKe]) || [];
                                    return (
                                        <td key={hari} className={`pc-schedule-cell ${cells.length ? "pc-cell-filled" : ""}`}
                                            title={`Jam ${jamKe} (${waktuLabel})`}>
                                            {cells.length > 0 ? cells.map((cell, idx2) => (
                                                <div key={idx2} className="pc-cell-content pc-cell-guru-view">
                                                    <span className="pc-cell-mapel">{cell.mapel_nama}</span>
                                                    <span className="pc-cell-rombel">{cell.rombel_nama}</span>
                                                    <span className="pc-cell-waktu">{waktuLabel}</span>
                                                </div>
                                            )) : (
                                                <div className="pc-cell-content pc-cell-empty">
                                                    <span style={{ fontSize: 11, color: '#cbd5e1' }}>Jam {jamKe}</span>
                                                    <span style={{ fontSize: 10, color: '#e2e8f0' }}>{waktuLabel}</span>
                                                </div>
                                            )}
                                        </td>
                                    );
                                })}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    }

    renderSimpleMatrix(jadwalMatrix, hariList, maxJam) {
        return (
            <div className="pc-table-container">
                <table className="pc-schedule-table pc-schedule-premium">
                    <thead>
                        <tr>
                            <th className="pc-th-jam">Jam</th>
                            {hariList.map((h) => <th key={h} className="pc-th-hari">{this.renderHariLabel(h)}</th>)}
                        </tr>
                    </thead>
                    <tbody>
                        {Array.from({ length: maxJam }, (_, i) => i + 1).map((jam) => (
                            <tr key={jam}>
                                <td className="pc-jam-cell">{jam}</td>
                                {hariList.map((hari) => {
                                    const cells = (jadwalMatrix[hari] && jadwalMatrix[hari][jam]) || [];
                                    return (
                                        <td key={hari} className={`pc-schedule-cell ${cells.length ? "pc-cell-filled" : ""}`}>
                                            {cells.map((cell, idx) => (
                                                <div key={idx} className="pc-cell-content pc-cell-guru-view">
                                                    <span className="pc-cell-mapel">{cell.mapel_nama}</span>
                                                    <span className="pc-cell-rombel">{cell.rombel_nama}</span>
                                                </div>
                                            ))}
                                        </td>
                                    );
                                })}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    }

    render() {
        const { guru_list, versi_list, selected_guru, selected_versi, loading, tahun_ajaran, semester, kurikulum } = this.state;

        const hasData = guru_list.length > 0;
        const hasVersi = versi_list.length > 0;

        if (!loading && hasData && !selected_guru) {
            setTimeout(() => {
                if (!this.state.selected_guru && this.state.guru_list.length > 0) {
                    this.setState({ selected_guru: this.state.guru_list[0].guru_nama }, () => this.loadJadwal());
                }
            }, 0);
        }

        return (
            <div className="pc-container">
                <div className="pc-header">
                    <div className="pc-header-content">
                        <div className="pc-header-text">
                            <h1 className="pc-header-title"><i className="bx bx-id-card"></i> Jadwal Per Guru</h1>
                            <p className="pc-header-subtitle">Lihat jadwal mengajar setiap guru</p>
                        </div>
                        <div className="pc-header-actions">
                            <Link to="/penjadwalan-cerdas" className="pc-btn pc-btn-outline"><i className="bx bx-arrow-back"></i> Dashboard</Link>
                        </div>
                    </div>
                </div>

                {/* Step-by-step Filter Guide */}
                <div className="pc-filters-guide">
                    <div className="pc-filter-step">
                        <div className="pc-step-badge">1</div>
                        <div className="pc-filter-item">
                            <label>Tahun Ajaran</label>
                            <select className="pc-input" value={tahun_ajaran}
                                onChange={(e) => this.onFilterChange({ tahun_ajaran: e.target.value })}>
                                {this.getTahunAjaranOptions().map((ta) => <option key={ta} value={ta}>{ta}</option>)}
                            </select>
                        </div>
                    </div>

                    <div className="pc-filter-step">
                        <div className="pc-step-badge">2</div>
                        <div className="pc-filter-item">
                            <label>Semester</label>
                            <select className="pc-input" value={semester}
                                onChange={(e) => this.onFilterChange({ semester: e.target.value })}>
                                <option value="1">Ganjil</option>
                                <option value="2">Genap</option>
                            </select>
                        </div>
                    </div>

                    <div className="pc-filter-step">
                        <div className="pc-step-badge">3</div>
                        <div className="pc-filter-item">
                            <label>Kurikulum</label>
                            <select className="pc-input" value={kurikulum}
                                onChange={(e) => this.onFilterChange({ kurikulum: e.target.value })}>
                                <option value="merdeka">Merdeka</option>
                                <option value="k13">K13</option>
                            </select>
                        </div>
                    </div>

                    <div className="pc-filter-step">
                        <div className="pc-step-badge">4</div>
                        <div className="pc-filter-item">
                            <label>Versi {!hasVersi && !loading && <span className="pc-filter-hint">(belum ada)</span>}</label>
                            <select className="pc-input" value={selected_versi}
                                disabled={!hasVersi}
                                onChange={(e) => this.setState({ selected_versi: e.target.value }, () => this.loadJadwal())}>
                                <option value="">Versi Aktif</option>
                                {versi_list.map((v) => <option key={v.id} value={v.id}>{v.nama_versi}{v.is_aktif ? " ✓" : ""}</option>)}
                            </select>
                        </div>
                    </div>

                    <div className="pc-filter-step">
                        <div className="pc-step-badge pc-step-badge-primary">5</div>
                        <div className="pc-filter-item">
                            <label>Guru {hasData && <span className="pc-filter-count">{guru_list.length} tersedia</span>}</label>
                            <select className="pc-input pc-input-highlight" value={selected_guru}
                                disabled={!hasData}
                                onChange={(e) => this.setState({ selected_guru: e.target.value }, () => this.loadJadwal())}>
                                <option value="">-- Pilih Guru --</option>
                                {guru_list.map((g) => <option key={g.guru_nama} value={g.guru_nama}>{g.guru_nama}</option>)}
                            </select>
                        </div>
                    </div>

                    <div className="pc-export-btns">
                        <button onClick={() => this.exportPdf()} className="pc-btn pc-btn-export pc-btn-pdf" title="Export PDF" disabled={!selected_guru}>
                            <i className="bx bxs-file-pdf"></i> PDF
                        </button>
                        <button onClick={() => this.exportExcel()} className="pc-btn pc-btn-export pc-btn-excel" title="Export Excel" disabled={!selected_guru}>
                            <i className="bx bxs-file-export"></i> Excel
                        </button>
                    </div>
                </div>

                {!loading && !hasData && (
                    <div className="pc-info-banner pc-info-warning">
                        <i className="bx bx-info-circle"></i>
                        <div>
                            <strong>Belum ada jadwal</strong>
                            <p>Tidak ditemukan jadwal untuk filter yang dipilih. Pastikan sudah generate jadwal terlebih dahulu di Wizard.</p>
                        </div>
                    </div>
                )}

                {loading ? (
                    <div className="pc-loading"><i className="bx bx-loader-alt bx-spin"></i> Memuat jadwal...</div>
                ) : selected_guru ? (
                    <div className="pc-section">
                        <div className="pc-section-header-row">
                            <h2 className="pc-section-title">
                                <i className="bx bx-id-card"></i> Jadwal Guru — {selected_guru}
                            </h2>
                            <span className="pc-section-meta">{tahun_ajaran} • Semester {semester}</span>
                        </div>
                        <div id="jadwal-print-area">
                            {this.renderMatrix()}
                        </div>
                    </div>
                ) : hasData ? (
                    <div className="pc-section">
                        <div className="pc-empty-state">
                            <i className="bx bx-select-multiple"></i>
                            <p>Pilih guru di atas untuk melihat jadwal</p>
                            <small>{guru_list.length} guru tersedia</small>
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }
}